module.exports = window.__loadPromiseRequirejs__("tpaGfppData");